import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { canAccess } from '../config/accessControl';
import { useAuth } from '../context/AuthContext';
import { ROUTE_PATHS } from './routePaths';

function ProtectedRoute({ roles = [], permission }) {
  const { user, isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="grid min-h-screen place-items-center bg-surface-page text-sm text-content-muted">
        Verificando sesión…
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (
    user.must_change_password &&
    location.pathname !== ROUTE_PATHS.CHANGE_PASSWORD
  ) {
    return <Navigate to={ROUTE_PATHS.CHANGE_PASSWORD} replace />;
  }

  if (!canAccess(user, roles, permission)) {
    if (user.role === 'VOTANTE') {
      return <Navigate to={ROUTE_PATHS.VOTER_PROFILE} replace />;
    }
    return <Navigate to="/acceso-denegado" replace />;
  }

  return <Outlet />;
}

export default ProtectedRoute;
